export class AdminAudit {
  public EntityName: string;
  public EntityID: string;
  public ChangeType: string;
  public ModifiedBy: string;
  public ModifiedAt: Date;
  public ChangeDescription: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
